import { withoutAuth } from 'hocs/withoutAuth'
import dynamic from 'next/dynamic'

const ResetPasswordPage = dynamic(
  () => import('containers/Auth/ResetPasswordPage')
)

export default withoutAuth(ResetPasswordPage)
